import { Badge } from 'antd';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { getSeverityColor } from '../../logic/store/Insights/InsightsModels';

const SingleRowContainer = styled.div`
	width: 100%;
	
	display: flex;
	flex-direction: row;
	
	margin-top: 12px;
	padding: 12px 16px;

	background-color: #fafafa;

	border: 1px solid #d9d9d9;
	border-radius: 2px;
	
	cursor: pointer;

	&:first-child {
		margin-top: 2px;
	}
	`;

interface ISingleRowProps
{
	Id: string;
	Name: string;
	NumberOfItemsTitle: string;
	NumberOfItems: number;
	Severity?: string;
	SeverityCount?: number;

	onSelect: (Id: string) => void;
}

export const SingleRow = (props: ISingleRowProps) =>
{
	const theme = useTheme();

	const { Id, Name, NumberOfItems, NumberOfItemsTitle, Severity, SeverityCount, onSelect } = props;

	return (
		<SingleRowContainer
			onClick={() => onSelect(Id)}
		>
			<div style={{ fontWeight: theme.fontWeights.bold }}>{Name}</div>
			{
				NumberOfItems > 0 &&
				<div style={{ marginLeft: 'auto' }}>{`${NumberOfItemsTitle}: ${NumberOfItems}`}</div>
			}
			{
				Severity &&
				<div style={{ display: 'flex', flexDirection: 'column', width: '5%', alignItems: 'flex-end', marginLeft: 'auto' }}>
					<Badge
						count={`${SeverityCount > 0 ? SeverityCount + ' ' : ''}${Severity.toUpperCase()}`}
						style={{
							backgroundColor: getSeverityColor(Severity),
							borderRadius: '4px',
							fontSize: '11px',
							fontWeight: theme.fontWeights.bold,
							padding: '0 8px',
							height: '20px',
							lineHeight: '20px'
						}} />
				</div>
			}
		</SingleRowContainer>
	);
};
